export class BairroWalkScore {
  cidade: string;
  bairro: string;
  walkscore: number;

  constructor(values?: any) {
    if (values) Object.assign(this, values);
  }
}
